export default [
    {
        path: "/security/roles",
        name: "roles",
        meta: { title: "roles", authRequired: true, privileges: ['SUPPLIER_MANAGE_USERS'] },
        component: () => import("../views/security/roles.vue"),
    },
    {
        path: "/security/users",
        name: "users",
        meta: { title: "users", authRequired: true, privileges: ['SUPPLIER_VIEW_USERS', 'SUPPLIER_MANAGE_USERS'] },
        component: () => import("../views/security/users.vue"),
    },
    {
        path: "/security/new-role",
        name: "new-role",
        meta: { title: "roles", authRequired: true, privileges: ['SUPPLIER_MANAGE_USERS'] },
        component: () => import("../views/security/new-role.vue"),
    },
    {
        path: "/security/new-user",
        name: "new-user",
        meta: { title: "users", authRequired: true, privileges: ['SUPPLIER_CREATE_USERS', 'SUPPLIER_UPDATE_USERS', 'SUPPLIER_MANAGE_USERS'] },
        component: () => import("../views/security/new-user.vue"),
    },
]
